import { render, staticRenderFns } from "./EditorController.vue?vue&type=template&id=0a107217&scoped=true"
import script from "./EditorController.vue?vue&type=script&lang=ts"
export * from "./EditorController.vue?vue&type=script&lang=ts"
import style0 from "./EditorController.vue?vue&type=style&index=0&id=0a107217&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a107217",
  null
  
)

export default component.exports